<button class="btn btn-outline-primary mb-4" (click)="loaderToggle()">Loader toggle</button>

<div class="row">
  <div class="col-120">
    <ui-form-group></ui-form-group>
  </div>

  <div class="col-120 mt-4">
    <ui-buttons></ui-buttons>
  </div>

  <div class="col-120 mt-4">
    <ui-links></ui-links>
  </div>

  <div class="col-30 mt-4">
    <ui-checkbox></ui-checkbox>
  </div>

  <div class="col-30 mt-4">
    <ui-radio></ui-radio>
  </div>

  <div class="col-30 mt-4">
    <ui-switch></ui-switch>
  </div>

  <div class="col-120 mt-4">
    <ui-forms></ui-forms>
  </div>

  <div class="col-120 mt-4">
    <ui-tooltips></ui-tooltips>
  </div>

  <div class="col-120 mt-4">
    <ui-tables></ui-tables>
  </div>

  <div class="col-120 mt-4">
    <ui-pagination></ui-pagination>
  </div>

  <div class="col-120 mt-4">
    <ui-breadcrumbs></ui-breadcrumbs>
  </div>

  <div class="col-120 mt-4">
    <ui-tabs></ui-tabs>
  </div>

  <div class="col-120 mt-4">
    <ui-datepicker></ui-datepicker>
  </div>

  <div class="col-120 mt-4">
    <ui-toastr></ui-toastr>
  </div>

  <div class="col-120 mt-4">
    <ui-modals></ui-modals>
  </div>
</div>
